import { useMemo } from "react";

export function useDrawerPermissions(drawer, user) {
  return useMemo(() => {
    const userId = Number(user?.id);
    const isPrivileged = String(user?.acesso) !== "1";
    const isEditor = drawer?.editors?.map(Number).includes(userId) ?? false;
    const isReporter = Number(drawer?.data?.reportado_por) === userId;
    const isOpen = String(drawer?.data?.estado) === "1";
    const canEdit = isPrivileged || isEditor || isReporter;

    return {
      canEdit,
      canDelete: canEdit,
      canClose: canEdit && isOpen,
      canUpload: canEdit && isOpen,
      canAssignRules: canEdit,
      canExport: canEdit,
      canFeature: drawer?.object === "nearmisses" && String(user?.acesso) === "3"
    };
  }, [drawer?.data?.estado, drawer?.data?.reportado_por, drawer?.editors, drawer?.object, user?.acesso, user?.id]);
}
